import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from "react";
import { estimateFood } from "../../api/nutrition.js";
import s from "./FoodPanel.module.css";
export default function FoodPanel({ entries, onAdd, onDelete, onUpdate }) {
    const [query, setQuery] = useState("");
    const [estimating, setEstimating] = useState(false);
    const [status, setStatus] = useState("");
    const [confirm, setConfirm] = useState(null);
    const [editKcal, setEditKcal] = useState(0);
    const [editProtein, setEditProtein] = useState(0);
    const [editing, setEditing] = useState(null);
    const inputRef = useRef(null);
    async function runEstimate() {
        const q = query.trim();
        if (!q)
            return;
        setEstimating(true);
        setConfirm(null);
        setStatus("Estimating…");
        try {
            const result = await estimateFood(q);
            setConfirm(result);
            setEditKcal(result.kcal);
            setEditProtein(result.proteinG);
            setStatus("");
        }
        catch {
            setConfirm({ name: q, kcal: 450, proteinG: 32, note: "demo estimate — edit before adding" });
            setEditKcal(450);
            setEditProtein(32);
            setStatus("");
        }
        finally {
            setEstimating(false);
        }
    }
    function handleAdd() {
        if (!confirm)
            return;
        onAdd({ name: confirm.name, kcal: editKcal, proteinG: editProtein });
        setQuery("");
        setConfirm(null);
        setStatus("");
        inputRef.current?.focus();
    }
    function handleDiscard() {
        setConfirm(null);
        setStatus("");
        setQuery("");
    }
    function startEdit(e) {
        setEditing({ id: e.id, kcal: e.kcal, proteinG: e.proteinG });
    }
    function saveEdit() {
        if (!editing)
            return;
        onUpdate(editing.id, { kcal: editing.kcal, proteinG: editing.proteinG });
        setEditing(null);
    }
    function cancelEdit() {
        setEditing(null);
    }
    return (_jsxs("div", { className: s.panel, children: [entries.length > 0 && (_jsx("div", { className: s.foodLog, children: entries.map((e) => {
                    if (editing?.id === e.id) {
                        return (_jsxs("div", { className: `${s.fe} ${s.feEditing}`, children: [_jsx("span", { className: s.feName, children: e.name }), _jsxs("div", { className: s.feEditFields, children: [_jsx("input", { className: s.feEditInput, type: "number", min: 0, value: editing.kcal, onChange: (ev) => setEditing({ ...editing, kcal: parseInt(ev.target.value) || 0 }), onKeyDown: (ev) => { if (ev.key === "Enter")
                                                saveEdit(); if (ev.key === "Escape")
                                                cancelEdit(); }, autoFocus: true }), _jsx("span", { className: s.feEditSep, children: "kcal" }), _jsx("input", { className: s.feEditInput, type: "number", min: 0, value: editing.proteinG, onChange: (ev) => setEditing({ ...editing, proteinG: parseInt(ev.target.value) || 0 }), onKeyDown: (ev) => { if (ev.key === "Enter")
                                                saveEdit(); if (ev.key === "Escape")
                                                cancelEdit(); } }), _jsx("span", { className: s.feEditSep, children: "g" })] }), _jsx("button", { className: s.feEditSave, onClick: saveEdit, children: "\u2713" }), _jsx("button", { className: s.feDel, onClick: cancelEdit, children: "\u00D7" })] }, e.id));
                    }
                    return (_jsxs("div", { className: s.fe, children: [_jsx("span", { className: s.feName, onClick: () => startEdit(e), title: "Click to edit", children: e.name }), _jsxs("span", { className: s.feMac, onClick: () => startEdit(e), title: "Click to edit", children: [e.kcal, " kcal \u00B7 ", e.proteinG, "g"] }), _jsx("button", { className: s.feDel, onClick: () => onDelete(e.id), children: "\u00D7" })] }, e.id));
                }) })), _jsxs("div", { className: s.foodInputRow, children: [_jsx("input", { ref: inputRef, className: s.foodField, placeholder: "200g pork steak with a cup of rice\u2026", value: query, onChange: (e) => setQuery(e.target.value), onKeyDown: (e) => e.key === "Enter" && runEstimate() }), _jsx("div", { className: s.aiStatus, children: status }), confirm && (_jsxs("div", { className: `${s.confirmCard} ${s.confirmCardVisible}`, children: [_jsx("div", { className: s.ccName, children: confirm.name }), _jsxs("div", { className: s.ccMacros, children: [_jsxs("div", { className: s.ccM, children: [_jsx("div", { className: s.ccValCal, children: _jsx("input", { type: "number", min: 0, value: editKcal, onChange: (e) => setEditKcal(parseInt(e.target.value) || 0) }) }), _jsx("div", { className: s.ccLbl, children: "Kcal" })] }), _jsxs("div", { className: s.ccM, children: [_jsx("div", { className: s.ccValProt, children: _jsx("input", { type: "number", min: 0, value: editProtein, onChange: (e) => setEditProtein(parseInt(e.target.value) || 0) }) }), _jsx("div", { className: s.ccLbl, children: "Protein g" })] })] }), confirm.note && _jsx("div", { className: s.ccNote, children: confirm.note }), _jsxs("div", { className: s.ccActions, children: [_jsx("button", { className: `${s.ccBtn} ${s.ccBtnConfirm}`, onClick: handleAdd, children: "Add to log" }), _jsx("button", { className: `${s.ccBtn} ${s.ccBtnDiscard}`, onClick: handleDiscard, children: "Discard" })] })] })), _jsx("button", { className: s.estBtn, onClick: runEstimate, disabled: estimating, children: "Estimate with AI" })] })] }));
}
//# sourceMappingURL=FoodPanel.js.map